import { vuexHandbookPage } from '@/store/composition/page/handbookPage'
import { PTO_HANDBOOK_COST_PERSON_HOUR_URL } from '@/api/pto/handbook'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexHandbookPage.createState(),
  tableHeaders: [
    {
      title: 'Название',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Стоимость чел/час',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'date_from'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'date_to'
    }
  ],
  urlApi: PTO_HANDBOOK_COST_PERSON_HOUR_URL
})

const getters = {
  ...vuexHandbookPage.createGetters(),
  getList: state => {
    return state.list.map(item => {
      console.log(item)
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.name || '-',
          item.price !== 0 ? priceFormat(item.price) : '-',
          item.date_from || '-',
          item.date_to || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexHandbookPage.createMutations()
}

const actions = {
  ...vuexHandbookPage.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
